// extracted by mini-css-extract-plugin
export default {"infoSection":"section_infoSection__7pX-0"};